module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/zh-hans_6-266b53a1f30d7b0c295796724271127b.jpg";